import React from 'react'
import Logo from './logo.svg'

import './Header.css'

export default function Header() {
    return (
        <header className="header-container">
            <div className="logo-container">
                <img src={Logo} alt="Logo" />
            </div>

            <h1>
                <span>
                    We are launching
                 </span> soon!
            </h1>

            <p>
                Subscribe and get notified
            </p>
        </header>
    )
}